var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.testtextbool)?_c('div',{staticClass:"cat-test"},[_vm._v("\n            "+_vm._s(_vm.showtel)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }